// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`ProjectSiteContact model belongsTo relations 1`] = `
Array [
  "ProjectSite",
  "Contact",
]
`;
